import { type FC } from "react";
import TriggeredConfirmationModal from "../../triggeredConfirmationModal/TriggerableConfirmationModal";
import { Typography } from "../../common/Typography/Typography";
import type { IObservable } from "../../../interfaces";
import { NavLink } from "react-router";
import environmentConfig from "configuration/environmentConfig";

interface RemoveFromBlackListProps {
  onTriggerModalObserver: IObservable<(onConfirm: () => void) => void>;
}

const helpCenterLink = environmentConfig.helpCenterUrl;
const helpCenterRelativeUrls = environmentConfig.helpCenterRelativeUrls;
const supportLink = `${helpCenterLink}/${helpCenterRelativeUrls.noContactUrl}`;

const RemoveFromBlackList: FC<RemoveFromBlackListProps> = ({ onTriggerModalObserver }) => {
  return (
    <TriggeredConfirmationModal
      title="Remove from No Contact List"
      content={
        <div>
          <Typography variant="title1">
            The selected user(s) will be removed from the email and messages no contact list and will begin receiving
            non-critical communications from the platform. This includes updates such as content prioritization, group
            additions, and daily or weekly digests. You can add them to the no contact list at any time.
          </Typography>
          <br />
          <NavLink target="_blank" style={{ textDecoration: "underline" }} to={supportLink}>
            Learn more in our Help Center
          </NavLink>
        </div>
      }
      confirmButtonLabel="Remove from List"
      onTriggerModalObserver={onTriggerModalObserver}
    />
  );
};

export default RemoveFromBlackList;
